export const inputCls =
  "w-full bg-white border border-midnight/15 px-3 py-2.5 text-sm text-midnight placeholder:text-midnight/35 outline-none focus:border-gold transition-colors";
export const labelCls = "block text-xs font-bold uppercase tracking-[0.12em] text-midnight/50 mb-1.5";
export const cardCls = "bg-white hairline shadow-soft";
export const thCls = "text-[10px] font-bold uppercase tracking-[0.15em] text-midnight/40";

export const fmtDate = (iso) => (iso ? new Date(iso).toLocaleDateString() : "—");
export const fmtDateTime = (iso) => (iso ? new Date(iso).toLocaleString() : "—");
export const fmtDuration = (s) => {
  if (!s) return "—";
  const m = Math.floor(s / 60);
  return m > 0 ? `${m}m ${s % 60}s` : `${s}s`;
};
